import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, Link } from "@mui/material";
import "./PreSurveyModal.css";
import { PRE_SURVEY_URL } from "../../hooks/use-with-ltik-session";

interface PreSurveyModalProps {
  open: boolean;
  surveyLink?: string;
}

export const PreSurveyModal: React.FC<PreSurveyModalProps> = ({
  open
}) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="pre-survey-dialog-title"
      aria-describedby="pre-survey-dialog-description"
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      style={{
        textAlign: "center",
      }}
    >
      <DialogTitle id="pre-survey-dialog-title">
        Pre-Survey Required
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="pre-survey-dialog-description">
          Before continuing, you'll need to complete a brief pre-survey.
        </DialogContentText>
        <DialogContentText sx={{ marginTop: 2 }}>
          <Link
            href={PRE_SURVEY_URL}
            underline="hover"
            sx={{ fontSize: "1.1rem", fontWeight: 500 }}
          >
            Click here to access the pre-survey
          </Link>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default PreSurveyModal;
